import React, { Fragment } from "react";
import moment from "moment";

const AdminFooter = (props) => {
  return (
    <Fragment>
      <footer className="bg-blue-800 text-gray-400 py-2 px-6 ">
       
        <div className="border-t border-gray-700 mt-1 ml-8 pt-2 text-center text-sm">
         Page AdminOnly © {moment().format("YYYY")} mlm. Tous droits réservés.
        </div>
      </footer>
    </Fragment>
  );
};

export default AdminFooter;
